/* eslint-disable array-callback-return */
// global
import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import MaskedInput from 'react-text-mask';
import Dropzone from 'react-dropzone';
// redux
import {
  create,
  update,
  getSignatureByProfessionalId
} from 'app/redux/actions/health-professional.action.js';
import { find, reset as resetAddress } from 'app/redux/actions/search-address.action';
import { ACTION } from 'app/redux/actions/modal/save-update-modal.action';
// utils
import { CPF_MASK, ZIP_MASK, PHONE_MASK } from 'app/utils/formUtils/masks';
import {
  removeReadOnly,
  isFormValid,
  isValidPassword,
  isValidCEP,
  isValidEmail
} from 'app/utils/formUtils/validators';
import { _val, isEmpty } from 'app/utils';
import _ from 'lodash';
// components
import { Form, Header, Icon } from 'semantic-ui-react';
import SaveUpdateNewModal from 'app/components/modals/SaveUpdateNewModal';
import ClientsDropdown from 'app/components/commons/dropdown/ClientsDropdown';
import BranchDropdown from 'app/components/commons/dropdown/BranchDropdown';
import ProfessionDropdown from 'app/components/commons/dropdown/ProfessionDropdown';
import HealthProfessionAssociationDropdown from 'app/components/commons/dropdown/HealthProfessionAssociationDropdown';
import HealthProfessionAssociationUFDropdown from 'app/components/commons/dropdown/HealthProfessionAssociationUFDropdown';
import LaborBondDropdown from 'app/components/commons/dropdown/LaborBondDropdown';
import BusinessPartnerDropdown from 'app/components/commons/dropdown/BusinessPartnerDropdown';
import PasswordLabel from 'app/components/commons/label/PasswordLabel';
import ErrorLabel from 'app/components/commons/label/ErrorLabel';
import CEPSearch from 'app/components/commons/search/CEPSearch';
import NotificationOverlay from 'app/components/commons/overlay/NotificationOverlay';
// config
import { GROUPS, LABOR_BOND } from 'app/config/consts';
import { CBOCODE } from 'app/config/profession';
// Style
import './HealthProfessionalModal.scss';
class HealthProfessionalModal extends Component {
  state = {
    form: this.initForm(),
    errors: {},
    isPasswordVisible: false,
    isPasswordVisibleConfirm: false
  };

  componentWillUnmount() {
    this.props.dispatch(resetAddress());
  }

  componentWillReceiveProps(nextProps) {
    const { isOpened: isOpenedP } = this.props.saveUpdateModal;
    const { isOpened: isOpenedN, action: actionN, data: dataN } = nextProps.saveUpdateModal;
    const { address } = nextProps.searchAddress;
    const { account } = this.props.auth;

    if (isOpenedP && isOpenedN && dataN.signature) {
      const signature = dataN.signature;
      this.setState(state => ({ ...state, form: { ...state.form, signature } }));
    }

    if (!isOpenedP && isOpenedN) {
      const values = actionN === ACTION.UPDATE ? dataN : {};

      if (account.groupId !== GROUPS.SALVUS_ADMIN) {
        values.clientId = account.client.id;
      }

      // if (actionN === ACTION.UPDATE) {
      //   this.props.dispatch(find(values.address.zipCode));
      // }

      if (account.businessPartnerId !== null) {
        this.setBussinessPartnerData(values, account.businessPartnerId);
      }

      if (Object.keys(values).includes('id') && values.id && !values.signature) {
        this.props.dispatch(getSignatureByProfessionalId(values.id, values, true));
      }

      this.setState({ form: this.initForm(values), errors: {} });
    } else {
      const { form } = this.state;
      const isUpdate = ACTION.UPDATE === actionN;
      if (!isUpdate) {
        if (address) {
          this.setState({ form: this.setAddressData(form, address) });
        } else {
          this.setAddressData(form);
          this.setState({ form });
        }
      }
    }
  }

  initForm(values = {}) {
    const contact = _val(values.contact, undefined);
    const address = _val(values.address, undefined);
    return {
      cpf: _val(values.cpf, undefined),
      name: _val(values.name, undefined),
      password: _val(values.password, undefined),
      confirmPassword: _val(values.confirmPassword, undefined),
      clientId: _val(values.clientId, undefined),
      branchId: _val(values.branchId, undefined),
      professionId: _val(values.professionId, undefined),
      CBOCode: _val(values.CBOCode, undefined),
      code: _val(values.code, undefined),
      registry: _val(values.registry, undefined),
      registryEntity: _val(values.registryEntity, undefined),
      healthProfessionAssociationId: _val(values.healthProfessionAssociationId, undefined),
      healthProfessionAssociationUFId: _val(values.healthProfessionAssociationUFId, undefined),
      laborBond: _val(values.laborBond, undefined),
      businessPartnerId: _val(values.businessPartnerId, undefined),
      signature: _val(values.signature, undefined),

      phone: contact ? _val(values.contact.phone, undefined) : undefined,
      email: contact ? _val(values.contact.email, undefined) : undefined,
      contactId: contact ? _val(values.contact.id, undefined) : undefined,

      zipCode: address ? _val(values.address.zipCode, undefined) : undefined,
      address: address ? _val(values.address.address, undefined) : undefined,
      number: address ? _val(values.address.number, undefined) : undefined,
      district: address ? _val(values.address.district, undefined) : undefined,
      city: address ? _val(values.address.city, undefined) : undefined,
      state: address ? _val(values.address.state, undefined) : undefined,
      complement: address ? _val(values.address.complement, undefined) : undefined,
      addressId: address ? _val(values.address.id, undefined) : undefined
    };
  }

  setAddressData(form, address = {}) {
    form.address = _val(address.address, '');
    form.state = _val(address.state, '');
    form.district = _val(address.district, '');
    form.city = _val(address.city, '');

    return form;
  }

  setBussinessPartnerData(form, businessPartnerId) {
    form.laborBond = LABOR_BOND.COLABORADOR;
    form.businessPartnerId = businessPartnerId;
  }

  validateForm(form, field) {
    const errors = {};
    const { saveUpdateModal } = this.props;
    const { action } = saveUpdateModal;

    const name = form.name;
    if (!field || field === 'name') {
      if (isEmpty(name)) {
        errors['name'] = 'O campo Nome é obrigatório.';
      } else {
        errors['name'] = undefined;
      }
    }

    const cpf = form.cpf;
    if (!field || field === 'cpf') {
      if (isEmpty(cpf)) {
        errors['cpf'] = 'O campo CPF é obrigatório.';
      } else {
        errors['cpf'] = undefined;
      }
    }

    const branchId = form.branchId;
    if (!field || field === 'branchId') {
      if (isEmpty(branchId)) {
        errors['branchId'] = 'O campo Filial é obrigatório.';
      } else {
        errors['branchId'] = undefined;
      }
    }

    const phone = form.phone;
    if (!field || field === 'phone') {
      if (isEmpty(phone)) {
        errors['phone'] = 'O campo Telefone é obrigatório.';
      } else {
        errors['phone'] = undefined;
      }
    }

    const professionId = form.professionId;
    if (!field || field === 'professionId') {
      if (isEmpty(professionId)) {
        errors['professionId'] = 'O campo profissão é obrigatório.';
      } else {
        errors['professionId'] = undefined;
      }
    }

    const registry = form.registry;
    if (!field || field === 'registry') {
      const isAttendantProfessional =
        _.toLower(this.state.form.CBOCode) === _.toLower(CBOCODE.ATTENDANT);

      if (isEmpty(registry) && !isAttendantProfessional) {
        errors['registry'] = 'O campo Registro é obrigatório.';
      } else {
        errors['registry'] = undefined;
      }
    }

    const healthProfessionAssociation = form.healthProfessionAssociationId;
    if (!field || field === 'healthProfessionAssociationId') {
      const isAttendantProfessional =
        _.toLower(this.state.form.CBOCode) === _.toLower(CBOCODE.ATTENDANT);

      if (isEmpty(healthProfessionAssociation) && !isAttendantProfessional) {
        errors['healthProfessionAssociationId'] = 'O campo Associação é obrigatório.';
      } else {
        errors['healthProfessionAssociationId'] = undefined;
      }
    }

    const healthProfessionAssociationUF = form.healthProfessionAssociationUFId;
    if (!field || field === 'healthProfessionAssociationUFId') {
      const isAttendantProfessional =
        _.toLower(this.state.form.CBOCode) === _.toLower(CBOCODE.ATTENDANT);

      if (isEmpty(healthProfessionAssociationUF) && !isAttendantProfessional) {
        errors['healthProfessionAssociationUFId'] = 'O campo UF é obrigatório.';
      } else {
        errors['healthProfessionAssociationUFId'] = undefined;
      }
    }

    const entity = form.registryEntity;
    if (!field || field === 'registryEntity') {
      if (isEmpty(entity) && form.healthProfessionAssociationId === 10) {
        errors['registryEntity'] = 'O campo Entidade é obrigatório.';
      } else {
        errors['registryEntity'] = undefined;
      }
    }

    const laborBond = form.laborBond;
    if (!field || field === 'laborBond') {
      if (isEmpty(laborBond)) {
        errors['laborBond'] = 'O campo Vínculo é obrigatório.';
      } else {
        errors['laborBond'] = undefined;
      }
    }

    if (form.laborBond === LABOR_BOND.COLABORADOR) {
      if (!field || field === 'businessPartnerId') {
        if (isEmpty(form.businessPartnerId)) {
          errors['businessPartnerId'] = 'O campo de parceiro de negócio é obrigatório.';
        } else {
          errors['businessPartnerId'] = undefined;
        }
      }
    }

    if (!field || field === 'password' || field === 'confirmPassword') {
      const password = form.password;
      const confirmPassword = form.confirmPassword;
      if (action === ACTION.ADD) {
        if (isEmpty(password)) {
          errors['password'] = 'O campo senha é obrigatório';
          errors['confirmPassword'] = 'As campo confirmar senha é obrigatório';
        } else {
          if (password !== confirmPassword) {
            errors['password'] = 'As senhas não coincidem';
            errors['confirmPassword'] = 'As senhas não coincidem';
          } else if (password === confirmPassword) {
            errors['password'] = undefined;
            errors['confirmPassword'] = undefined;
          } else if (action === ACTION.ADD) {
            if (password.length === 0 || password.length < 8 || password.length > 20) {
              errors['password'] = 'O campo senha não possui um tamanho adequado.';
            } else if (!isValidPassword(password)) {
              errors['password'] = 'O campo senha não é válido.';
            } else {
              errors['password'] = undefined;
            }

            if (
              confirmPassword.length === 0 ||
              confirmPassword.length < 8 ||
              confirmPassword.length > 20
            ) {
              errors['confirmPassword'] = 'O campo confirmar senha não possui um tamanho adequado.';
            } else if (!isValidPassword(confirmPassword)) {
              errors['confirmPassword'] = 'O campo confirmar senha não é válido.';
            } else {
              errors['confirmPassword'] = undefined;
            }
          }
        }
      }
    }

    const email = form.email;
    if (!field || field === 'email') {
      if (!isEmpty(email)) {
        if (!isValidEmail(email)) {
          errors['email'] = 'O campo email não é válido.';
        } else {
          errors['email'] = undefined;
        }
      } else {
        errors['email'] = undefined;
      }
    }

    const zipCode = form.zipCode;
    if (!field || field === 'zipCode') {
      if (isEmpty(zipCode)) {
        errors['zipCode'] = 'O campo CEP é obrigatório.';
      } else {
        errors['zipCode'] = undefined;
      }
    }

    const state = form.state;
    if (!field || field === 'state') {
      if (isEmpty(state)) {
        errors['state'] = 'O campo Estado é obrigatório.';
      } else {
        errors['state'] = undefined;
      }
    }

    const city = form.city;
    if (!field || field === 'city') {
      if (isEmpty(city)) {
        errors['city'] = 'O campo Cidade é obrigatório.';
      } else {
        errors['city'] = undefined;
      }
    }

    const district = form.district;
    if (!field || field === 'district') {
      if (isEmpty(district)) {
        errors['district'] = 'O campo Bairro é obrigatório.';
      } else {
        errors['district'] = undefined;
      }
    }

    const address = form.address;
    if (!field || field === 'address') {
      if (isEmpty(address)) {
        errors['address'] = 'O campo Endereço é obrigatório.';
      } else {
        errors['address'] = undefined;
      }
    }

    const number = form.number;
    if (!field || field === 'number') {
      if (isEmpty(number)) {
        errors['number'] = 'O campo Número é obrigatório.';
      } else {
        errors['number'] = undefined;
      }
    }

    return errors;
  }

  onChange = field => (e, target) => {
    const { value } = target || e.target;
    let { form, errors } = this.state;

    if (field === 'zipCode' && isValidCEP(value)) {
      this.props.dispatch(find(value));
      errors['state'] = undefined;
      errors['city'] = undefined;
      errors['district'] = undefined;
      errors['address'] = undefined;
    }

    if (field === 'laborBond') {
      form.businessPartnerId = null;
    }

    form[field] = value;

    const validations = this.validateForm(form, field);
    const keys = Object.keys(validations);
    keys.forEach(key => (errors[key] = validations[key]));
    this.setState({ form, errors });
  };

  onChangeProfession = field => (e, target) => {
    const { value, options } = target || e.target;
    let { form, errors } = _.cloneDeep(this.state);

    const option = options.find(option => parseInt(option.value) === parseInt(value));

    if (!option) {
      return;
    }

    const CBOCode = _.toLower(option.addons.CBOCode);
    const isAttendantProfessional = CBOCode === _.toLower(CBOCODE.ATTENDANT);

    if (isAttendantProfessional) {
      form.registry = '';
      form.healthProfessionAssociationUFId = null;
      form.healthProfessionAssociationId = null;
    }

    form.CBOCode = CBOCode;
    form[field] = value;

    const validations = this.validateForm(form, field);
    const keys = Object.keys(validations);
    keys.forEach(key => (errors[key] = validations[key]));
    this.setState({ form, errors });
  };

  dropFile = files => {
    const { form } = this.state;
    const { signature } = form;
    const reader = new FileReader();

    if (!signature) {
      files.map(file => {
        reader.onload = () => {
          const uri = reader.result;
          form.signature = uri;
          this.setState({ form });
        };
        reader.readAsDataURL(file);
      });
    }
  };

  dropStyle = events => {
    const {
      // draggedFiles,
      fileRejections,
      isDragAccept,
      isDragActive,
      isDragReject,
      isFileDialogActive
    } = events;

    const style = {
      style: 'dropzone-basestyle',
      text: null
    };

    if (isDragActive || isFileDialogActive) {
      style.style = 'dropzone-basestyle-active';
      style.text = 'Imagem sendo escolhida.';
    }
    if (isDragAccept) {
      style.style = 'dropzone-basestyle-accept';
      style.text = 'Tipo e quantidade de imagem correto.';
    }

    if (isDragReject || !_.isEmpty(fileRejections)) {
      style.style = 'dropzone-basestyle-reject';
      style.text = 'Error o tipo ou a quantidade de imagens incorreto.';
    }

    return style;
  };

  deleteSignature = () => {
    const { form } = this.state;
    form.signature = null;
    this.setState({ form });
  };
  hasError = field => !isEmpty(this.state.errors[field]);

  onConfirmModal = () => {
    const errors = this.validateForm(this.state.form);
    if (!isFormValid(errors)) {
      this.setState({ errors });
      return false;
    }

    const { form } = this.state;
    const { action, data } = this.props.saveUpdateModal;
    if (action === ACTION.ADD) {
      this.props.dispatch(create(form));
    } else if (action === ACTION.UPDATE) {
      const professional = form;
      this.props.dispatch(update(data.id, professional));
    }

    return false;
  };

  render() {
    const { dispatch, saveUpdateModal, auth, searchAddress, healthProfessional } = this.props;

    const { action, size, isOpened, loading, error } = saveUpdateModal;
    const { account } = auth;
    const { businessPartnerId } = account;
    const { loading: loadingSignature } = healthProfessional;
    const { searching } = searchAddress;

    const isAttendantProfessional =
      _.toLower(this.state.form.CBOCode) === _.toLower(CBOCODE.ATTENDANT);

    const options = {
      dispatch,
      title: 'PROFISSIONAL',
      onConfirmModal: this.onConfirmModal,
      action,
      size,
      isOpened,
      loading,
      disableConfirmationButton: loadingSignature,
      error
    };

    const { form, errors } = this.state;

    const errorOptions = {
      isError: true,
      errors:
        errors &&
        Object.values(errors)
          .map(err => {
            if (err)
              return {
                key: err
              };
          })
          .filter(elem => elem)
    };

    return (
      <SaveUpdateNewModal id='modal' options={options}>
        <Form>
          {!isFormValid(errors) && <NotificationOverlay options={errorOptions} />}
          <Form.Group>
            <Form.Input
              label={<ErrorLabel label='Código' error={errors['code']} />}
              placeholder='Código'
              width={3}
              value={form.code}
              onChange={this.onChange('code')}
              error={this.hasError('code')}
              readOnly
              onFocus={removeReadOnly}
            />
            <Form.Input
              label={<ErrorLabel label='Nome' error={errors['name']} />}
              placeholder='Nome'
              required
              width={13}
              value={form.name}
              onChange={this.onChange('name')}
              error={this.hasError('name')}
              readOnly
              onFocus={removeReadOnly}
            />
          </Form.Group>
          <Form.Group>
            <div className='formRow'>
              <div className={account.groupId === GROUPS.SALVUS_ADMIN ? 'col-3' : 'col-2'}>
                <ProfessionDropdown
                  width={16}
                  required
                  value={form.professionId}
                  onChange={this.onChangeProfession('professionId')}
                  error={this.hasError('professionId')}
                />
              </div>

              {account.groupId === GROUPS.SALVUS_ADMIN && (
                <div className='col-3'>
                  <ClientsDropdown
                    width={16}
                    value={form.clientId}
                    onChange={this.onChange('clientId')}
                    error={errors['clientId']}
                  />
                </div>
              )}
              <div className={account.groupId === GROUPS.SALVUS_ADMIN ? 'col-3' : 'col-2'}>
                <BranchDropdown
                  width={16}
                  required
                  value={form.branchId}
                  onChange={this.onChange('branchId')}
                  error={errors['branchId']}
                />
              </div>
            </div>
          </Form.Group>
          <Form.Group>
            <div className='formRow'>
              <div className='col-2'>
                <Form.Input
                  label={<ErrorLabel label='Telefone' error={errors['phone']} />}
                  placeholder='Telefone'
                  required
                  control={MaskedInput}
                  mask={PHONE_MASK}
                  value={form.phone}
                  onChange={this.onChange('phone')}
                  error={this.hasError('phone')}
                  readOnly
                  onFocus={removeReadOnly}
                />
              </div>
              <div className='col-2'>
                <Form.Input
                  label={<ErrorLabel label='CPF' error={errors['cpf']} />}
                  placeholder='CPF'
                  required
                  value={form.cpf}
                  control={MaskedInput}
                  mask={CPF_MASK}
                  onChange={this.onChange('cpf')}
                  error={this.hasError('cpf')}
                  readOnly
                  onFocus={removeReadOnly}
                />
              </div>
            </div>
          </Form.Group>
          <Form.Group>
            <div className='formRow'>
              <div className='col-2'>
                <Form.Input
                  label={<ErrorLabel label='Registro' error={errors['registry']} />}
                  placeholder='Registro'
                  value={form.registry}
                  onChange={this.onChange('registry')}
                  error={this.hasError('registry')}
                  readOnly
                  onFocus={removeReadOnly}
                  required={!isAttendantProfessional}
                  disabled={isAttendantProfessional}
                />
              </div>
              <div className='col-2' style={{ width: '30%' }}>
                <HealthProfessionAssociationUFDropdown
                  value={form.healthProfessionAssociationUFId}
                  onChange={this.onChange('healthProfessionAssociationUFId')}
                  error={this.hasError('healthProfessionAssociationUFId')}
                  required={!isAttendantProfessional}
                  disabled={isAttendantProfessional}
                />
              </div>
              <div className='col-2'>
                <HealthProfessionAssociationDropdown
                  value={form.healthProfessionAssociationId}
                  onChange={this.onChange('healthProfessionAssociationId')}
                  error={this.hasError('healthProfessionAssociationId')}
                  required={!isAttendantProfessional}
                  disabled={isAttendantProfessional}
                />
              </div>
            </div>
          </Form.Group>
          {businessPartnerId === null ? (
            <>
              {form.healthProfessionAssociationId === 10 && (
                <Form.Group>
                  <Form.Input
                    width={16}
                    label={<ErrorLabel label='Entidade' error={errors['registryEntity']} />}
                    placeholder='Entidade (COREN, CRM)'
                    value={form.registryEntity}
                    onChange={this.onChange('registryEntity')}
                    error={this.hasError('registryEntity')}
                    readOnly
                    onFocus={removeReadOnly}
                  />
                </Form.Group>
              )}
              <Form.Group>
                <div className='formRow'>
                  <LaborBondDropdown
                    width={16}
                    required
                    value={form.laborBond}
                    onChange={this.onChange('laborBond')}
                    error={errors['laborBond']}
                  />
                  {form.laborBond === LABOR_BOND.COLABORADOR ? (
                    <BusinessPartnerDropdown
                      width={16}
                      value={form.businessPartnerId}
                      onChange={this.onChange('businessPartnerId')}
                      error={errors['businessPartnerId']}
                    />
                  ) : null}
                </div>
              </Form.Group>
            </>
          ) : null}

          <Form.Group>
            <Form.Input
              label={<ErrorLabel label='Email' error={errors['email']} />}
              placeholder='Email'
              required
              value={form.email}
              width={16}
              onChange={this.onChange('email')}
              error={this.hasError('email')}
              readOnly
              onFocus={removeReadOnly}
            />
            <Form.Input
              label={<ErrorLabel label={<PasswordLabel />} error={errors['password']} />}
              placeholder='Senha'
              required={action === ACTION.ADD ? true : false}
              type={this.state.isPasswordVisible ? 'text' : 'password'}
              value={form.password}
              width={16}
              onChange={this.onChange('password')}
              error={this.hasError('password')}
              readOnly
              onFocus={removeReadOnly}
              icon={
                <Icon
                  name={this.state.isPasswordVisible ? 'eye slash' : 'eye'}
                  link
                  onClick={() =>
                    this.setState({
                      ...this.state,
                      isPasswordVisible: !this.state.isPasswordVisible
                    })
                  }
                />
              }
            />
            <Form.Input
              label={<ErrorLabel label='Confirmar Senha' error={errors['confirmPassword']} />}
              placeholder='Confirmar Senha'
              required={action === ACTION.ADD ? true : false}
              type={this.state.isPasswordVisibleConfirm ? 'text' : 'password'}
              value={form.confirmPassword}
              width={16}
              onChange={this.onChange('confirmPassword')}
              error={this.hasError('confirmPassword')}
              readOnly
              onFocus={removeReadOnly}
              icon={
                <Icon
                  name={this.state.isPasswordVisibleConfirm ? 'eye slash' : 'eye'}
                  link
                  onClick={() =>
                    this.setState({
                      ...this.state,
                      isPasswordVisibleConfirm: !this.state.isPasswordVisibleConfirm
                    })
                  }
                />
              }
            />
          </Form.Group>
          <div>
            <Header as='h5'>Endereço</Header>
            <Form.Group>
              {/* <Form.Field style={{ padding: 0 }} width={6}>
                <Form.Input
                  label={<ErrorLabel label='CEP' error={errors['zipCode']} />}
                  placeholder='CEP'
                  required
                  control={MaskedInput}
                  mask={ZIP_MASK}
                  width={16}
                  value={form.zipCode}
                  onChange={this.onChange('zipCode')}
                  error={this.hasError('zipCode')}
                  disabled={searching}
                  readOnly
                  onFocus={removeReadOnly}
                />
                <Icon
                  name={searching ? 'circle notch' : 'search'}
                  loading={searching}
                  style={{ position: 'relative', margin: 0, top: '-34px', left: '83%' }}
                />
              </Form.Field> */}

              <CEPSearch
                label={<ErrorLabel label='CEP' error={errors['zipCode']} />}
                placeholder='CEP'
                control={MaskedInput}
                mask={ZIP_MASK}
                value={form.zipCode}
                onChange={this.onChange('zipCode')}
                error={this.hasError('zipCode')}
                width={16}
                searching={searching}
                readOnly
                onFocus={removeReadOnly}
              />

              <Form.Input
                label={<ErrorLabel label='Estado' error={errors['state']} />}
                placeholder='Estado'
                width={8}
                value={form.state}
                onChange={this.onChange('state')}
                // onBlur={this.onChange('state')}
                error={this.hasError('state')}
                disabled={searching}
                readOnly
                onFocus={removeReadOnly}
              />
              <Form.Input
                label={<ErrorLabel label='Cidade' error={errors['city']} />}
                placeholder='Cidade'
                width={8}
                value={form.city}
                onChange={this.onChange('city')}
                error={this.hasError('city')}
                disabled={searching}
                readOnly
                onFocus={removeReadOnly}
              />
            </Form.Group>
            <Form.Group>
              <Form.Input
                label={<ErrorLabel label='Bairro' error={errors['district']} />}
                placeholder='Bairro'
                required
                width={6}
                value={form.district}
                onChange={this.onChange('district')}
                error={this.hasError('district')}
                disabled={searching}
                readOnly
                onFocus={removeReadOnly}
              />
              <Form.Input
                label={<ErrorLabel label='Endereço' error={errors['address']} />}
                placeholder='Endereço'
                required
                width={8}
                value={form.address}
                onChange={this.onChange('address')}
                error={this.hasError('address')}
                disabled={searching}
                readOnly
                onFocus={removeReadOnly}
              />
              <Form.Input
                label={<ErrorLabel label='Número' error={errors['number']} />}
                placeholder='Número'
                required
                width={4}
                value={form.number}
                onChange={this.onChange('number')}
                error={this.hasError('number')}
                readOnly
                onFocus={removeReadOnly}
              />
              <Form.Input
                label={<ErrorLabel label='Complemento' error={errors['complement']} />}
                placeholder='Complemento'
                width={4}
                type='complement'
                value={form.complement}
                onChange={this.onChange('complement')}
                error={this.hasError('complement')}
                readOnly
                onFocus={removeReadOnly}
              />
            </Form.Group>
            <Form.Group>
              <Form.Field width={16}>
                <ErrorLabel label='Imagem do carimbo e assinatura' error={errors['signature']} />
                <Dropzone onDrop={this.dropFile} accept='image/jpeg' maxFiles={1}>
                  {({ getRootProps, getInputProps, ...events }) => {
                    const { style, text } = this.dropStyle(events);
                    return (
                      <div className='dropzone-container' width={16}>
                        <div
                          {...getRootProps({
                            className: style
                          })}
                        >
                          <input {...getInputProps()} />
                          <p>
                            Click para escolher uma imagem ou arraste um arquivo para adicionar o
                            carimbo de assinatura.
                          </p>
                          <p>(Só aceitamos imagens jpg)</p>
                          <p>{text}</p>
                        </div>
                        <div className='dropzone-files'>
                          {form.signature && (
                            <div className='signature-file-wrapper'>
                              <img alt='' src={form.signature} className='signature-file' />
                              <span onClick={this.deleteSignature}>
                                <Icon name='close' className='signature-file-delete' size='large' />
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  }}
                </Dropzone>
              </Form.Field>
            </Form.Group>
          </div>
        </Form>
      </SaveUpdateNewModal>
    );
  }
}

HealthProfessionalModal.propTypes = {
  auth: PropTypes.object,
  nurses: PropTypes.object,
  dispatch: PropTypes.func,
  saveUpdateModal: PropTypes.object,
  searchAddress: PropTypes.object,
  profession: PropTypes.object,
  healthProfessional: PropTypes.object
};

const mapStateToProps = state => ({
  saveUpdateModal: state.saveUpdateModal,
  nurses: state.nurses,
  searchAddress: state.searchAddress,
  healthProfessional: state.healthProfessional,
  auth: state.auth
});

export default connect(mapStateToProps)(HealthProfessionalModal);
